import { render } from "./MedicationRow.vue?vue&type=template&id=573962d7"
import script from "./MedicationRow.vue?vue&type=script&lang=js"
export * from "./MedicationRow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__